import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import Success from "./pages/Success";
import NotFound from "./pages/NotFound";
import NosOffres from "./pages/NosOffres";
import Tutoriels from "./pages/Tutoriels";
import AvisClients from "./pages/AvisClients";
import IptvIphoneIpad from "./pages/tutoriels/IptvIphoneIpad";
import IptvAndroid from "./pages/tutoriels/IptvAndroid";
import IptvFirestick from "./pages/tutoriels/IptvFirestick";
import IptvSmartTvAndroid from "./pages/tutoriels/IptvSmartTvAndroid";
import IptvWindows from "./pages/tutoriels/IptvWindows";
import IptvMac from "./pages/tutoriels/IptvMac";
import AffiliateRegister from "./pages/AffiliateRegister";
import AffiliateDashboard from "./pages/AffiliateDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

// Pages SEO
import IptvFrance from "./pages/seo/IptvFrance";
import AbonnementIptv from "./pages/seo/AbonnementIptv";
import IptvPasCher from "./pages/seo/IptvPasCher";
import AbonnementIptv3Mois from "./pages/seo/AbonnementIptv3Mois";
import AbonnementIptv6Mois from "./pages/seo/AbonnementIptv6Mois";
import AbonnementIptv12Mois from "./pages/seo/AbonnementIptv12Mois";
import Faq from "./pages/Faq";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/nos-offres" element={<NosOffres />} />
            <Route path="/avis-clients" element={<AvisClients />} />
            <Route path="/success" element={<Success />} />
            <Route path="/affiliate" element={<AffiliateRegister />} />
            <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/tutoriels" element={<Tutoriels />} />
            <Route path="/tutoriels/iptv-iphone-ipad" element={<IptvIphoneIpad />} />
            <Route path="/tutoriels/iptv-android" element={<IptvAndroid />} />
            <Route path="/tutoriels/iptv-firestick" element={<IptvFirestick />} />
            <Route path="/tutoriels/iptv-smart-tv-android" element={<IptvSmartTvAndroid />} />
            <Route path="/tutoriels/iptv-windows" element={<IptvWindows />} />
            <Route path="/tutoriels/iptv-mac" element={<IptvMac />} />
            
            {/* Pages SEO */}
            <Route path="/iptv-france" element={<IptvFrance />} />
            <Route path="/abonnement-iptv" element={<AbonnementIptv />} />
            <Route path="/iptv-pas-cher" element={<IptvPasCher />} />
            <Route path="/abonnement-iptv-3-mois" element={<AbonnementIptv3Mois />} />
            <Route path="/abonnement-iptv-6-mois" element={<AbonnementIptv6Mois />} />
            <Route path="/abonnement-iptv-12-mois" element={<AbonnementIptv12Mois />} />
            <Route path="/faq" element={<Faq />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
